module.exports = __webpack_public_path__ + "img/business-finance-white.688e8768.svg";